<template>
  <NuxtLayout>
    <div class="-mx-4 flex flex-col items-center md:-mx-6 xl:-mx-[100px]">
      <BaseContainer class="flex justify-center">
        <div class="flex flex-col items-center justify-center px-4">
          <h1 class="mt-10 text-center text-6xl lg:mt-20 lg:text-9xl">
            {{ error?.statusCode }}
          </h1>
          <div
            class="text-md mb-20 mt-10 flex flex-col items-center space-y-10 lg:text-6xl"
          >
            <p class="text-center">
              {{ message }}
            </p>
            <NuxtLink to="/">
              <BaseButton size="xl" theme="white"
                >{{ $t('page_error.go_to_main_page') }}
              </BaseButton>
            </NuxtLink>
          </div>
        </div>
      </BaseContainer>
    </div>
  </NuxtLayout>
</template>
<script setup>
const props = defineProps({
  error: {
    type: [Object, null],
    default: null,
  },
})

const { t } = useI18n()

const message = computed(() => {
  if (props.error?.statusCode === 404) {
    return t('page_error.404')
  }

  return t('page_error.500')
})

useHead({
  title: 'Error',
  meta: [...useGenerateSeoMeta(''), { name: 'robots', content: 'noindex' }],
})
</script>
